interface TrashcanIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export default function TrashcanIcon(props: TrashcanIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={43.486}
      height={49.698}
      viewBox="0 0 43.486 49.698"
      {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        data-name="Icon awesome-trash-alt"
        d="M3.106 45.039A4.659 4.659 0 007.765 49.7h27.956a4.659 4.659 0 004.659-4.659V12.425H3.106zm26.4-24.849a1.553 1.553 0 013.106 0v21.743a1.553 1.553 0 01-3.106 0zm-9.318 0a1.553 1.553 0 013.106 0v21.743a1.553 1.553 0 01-3.106 0zm-9.318 0a1.553 1.553 0 013.106 0v21.743a1.553 1.553 0 01-3.106 0zM41.933 3.106H30.285l-.912-1.815A2.33 2.33 0 0027.286 0H16.191a2.3 2.3 0 00-2.077 1.291L13.2 3.106H1.553A1.553 1.553 0 000 4.659v3.106a1.553 1.553 0 001.553 1.553h40.38a1.553 1.553 0 001.553-1.553V4.659a1.553 1.553 0 00-1.553-1.553z"
      />
    </svg>
  )
}
